import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CDPlayerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CDPlayerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M7.91622 20.2207C4.98093 18.6439 3.15767 15.597 3.15767 12.2706C3.15767 7.29583 7.20499 3.24852 12.1797 3.24852C17.1545 3.24852 21.2018 7.29584 21.2018 12.2706C21.2018 12.7521 21.156 13.2548 21.0618 13.8073C21.0392 13.9383 21.0689 14.0706 21.1457 14.179C21.2225 14.2868 21.3367 14.3585 21.4664 14.3804C21.5987 14.4036 21.7304 14.3733 21.8375 14.2972C21.946 14.221 22.0176 14.1061 22.0396 13.9757C22.1441 13.3645 22.1951 12.8063 22.1951 12.2706C22.1951 6.74789 17.7025 2.25525 12.1797 2.25525C6.65769 2.25524 2.16504 6.74789 2.16504 12.2706C2.16504 15.9636 4.18838 19.3448 7.44507 21.0958C7.51736 21.1345 7.59803 21.1552 7.67935 21.1552C7.86329 21.1552 8.03174 21.0545 8.11822 20.8925C8.24666 20.6518 8.15631 20.3504 7.91622 20.2207Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.97136 6.35946C6.77774 6.16713 6.46149 6.16713 6.26916 6.35946C4.6918 7.93618 3.82373 10.035 3.82373 12.2707C3.82373 14.5057 4.6918 16.6046 6.26851 18.1819C6.36209 18.2749 6.4873 18.3265 6.62025 18.3265C6.7532 18.3265 6.87777 18.2749 6.97135 18.1819C7.16433 17.9883 7.16433 17.6734 6.9707 17.4791C5.58179 16.0908 4.81635 14.2405 4.81635 12.2707C4.81635 10.3009 5.5818 8.45056 6.97135 7.06166C7.16433 6.86804 7.16434 6.55308 6.97136 6.35946Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.0426 14.6703H10.9379C9.75165 14.6703 8.78613 15.6358 8.78613 16.8221V20.133C8.78613 21.3192 9.75165 22.2847 10.9379 22.2847H20.0426C21.2295 22.2847 22.195 21.3192 22.195 20.133V16.8221C22.195 15.6358 21.2295 14.6703 20.0426 14.6703ZM9.77941 16.8221C9.77941 16.1831 10.299 15.6636 10.9379 15.6636H20.0426C20.6816 15.6636 21.2017 16.1831 21.2017 16.8221V20.133C21.2017 20.7719 20.6816 21.2921 20.0426 21.2921H10.9379C10.299 21.2921 9.77941 20.7719 9.77941 20.133V16.8221Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.24269 14.5871C9.47762 14.4464 9.55442 14.1411 9.41501 13.9069C9.1078 13.3893 8.95161 12.8387 8.95161 12.2701C8.95161 10.4901 10.3999 9.04182 12.1799 9.04182C13.9599 9.04182 15.4082 10.4901 15.4082 12.2701C15.4082 12.6154 15.343 12.9665 15.2081 13.3447C15.1165 13.6022 15.252 13.8869 15.5102 13.9798C15.7703 14.0689 16.053 13.934 16.144 13.6784C16.3169 13.1918 16.4008 12.7309 16.4008 12.2701C16.4008 9.9428 14.5072 8.04919 12.1799 8.04919C9.85259 8.04919 7.95898 9.9428 7.95898 12.2701C7.95898 13.0098 8.16744 13.7513 8.56243 14.4142C8.6515 14.5639 8.81478 14.6568 8.98904 14.6568C9.07875 14.6568 9.16589 14.6329 9.24269 14.5871Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.27 12.2704C11.27 12.7719 11.6786 13.1804 12.18 13.1804C12.6822 13.1804 13.0907 12.7719 13.0907 12.2704C13.0907 11.7683 12.6822 11.3597 12.18 11.3597C11.6786 11.3597 11.27 11.7683 11.27 12.2704Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.4428 17.5737V19.3811C13.4428 19.6307 13.6451 19.833 13.8946 19.833C14.1442 19.833 14.3465 19.6307 14.3465 19.3811C14.3465 19.1316 14.5488 18.9293 14.7983 18.9293C15.0479 18.9293 15.2502 19.1316 15.2502 19.3811C15.2502 20.1298 14.6433 20.7367 13.8946 20.7367C13.146 20.7367 12.5391 20.1298 12.5391 19.3811V17.5737C12.5391 16.825 13.146 16.2181 13.8946 16.2181C14.6433 16.2181 15.2502 16.825 15.2502 17.5737C15.2502 17.8233 15.0479 18.0256 14.7983 18.0256C14.5488 18.0256 14.3465 17.8233 14.3465 17.5737C14.3465 17.3241 14.1442 17.1219 13.8946 17.1219C13.6451 17.1219 13.4428 17.3241 13.4428 17.5737Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.5519 16.2181H16.6482C16.3986 16.2181 16.1963 16.4205 16.1963 16.67V20.2849C16.1963 20.5344 16.3986 20.7367 16.6482 20.7367H17.5519C18.3002 20.7359 18.9066 20.1295 18.9074 19.3812V17.5737C18.9066 16.8254 18.3002 16.219 17.5519 16.2181ZM18.0037 19.3812C18.0034 19.6306 17.8013 19.8327 17.5519 19.833H17.1V17.1219H17.5519C17.8013 17.1222 18.0034 17.3243 18.0037 17.5737V19.3812Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CDPlayerIcon;
